import { TenantEntity } from '../TenantEntity'

export class IntegratedTruckingInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'IntegratedTruckingInfo'
  }

  get truckingInfoUuid() {
    return this._data.truckingInfoUuid
  }

  set truckingInfoUuid(truckingInfoUuid) {
    this._data.truckingInfoUuid = truckingInfoUuid
  }

  get dischargingWay() {
    return this._data.dischargingWay
  }

  set dischargingWay(dischargingWay) {
    this._data.dischargingWay = dischargingWay
  }

  get actDeliveryDate() {
    return this._data.actDeliveryDate
  }

  set actDeliveryDate(actDeliveryDate) {
    this._data.actDeliveryDate = actDeliveryDate
  }

  get doorName() {
    return this._data.doorName
  }

  set doorName(doorName) {
    this._data.doorName = doorName
  }

  get doorMan() {
    return this._data.doorMan
  }

  set doorMan(doorMan) {
    this._data.doorMan = doorMan
  }

  get doorManTel() {
    return this._data.doorManTel
  }

  set doorManTel(doorManTel) {
    this._data.doorManTel = doorManTel
  }

  get doorAddress() {
    return this._data.doorAddress
  }

  set doorAddress(doorAddress) {
    this._data.doorAddress = doorAddress
  }

  get city() {
    return this._data.city
  }

  set city(city) {
    this._data.city = city
  }

  get arriveDate() {
    return this._data.arriveDate
  }

  set arriveDate(arriveDate) {
    this._data.arriveDate = arriveDate
  }

  get actualArrivalDate() {
    return this._data.actualArrivalDate
  }

  set actualArrivalDate(actualArrivalDate) {
    this._data.actualArrivalDate = actualArrivalDate
  }
  get palletSum() {
    return this._data.palletSum
  }
  set palletSum(palletSum) {
    this._data.palletSum = palletSum
  }
  get po() {
    return this._data.po
  }
  set po(po) {
    this._data.po = po
  }
  get vehicleType() {
    return this._data.vehicleType
  }
  set vehicleType(vehicleType) {
    this._data.vehicleType = vehicleType
  }
  get trailerNumber() {
    return this._data.trailerNumber
  }
  set trailerNumber(trailerNumber) {
    this._data.trailerNumber = trailerNumber
  }
}

